import { render } from "./Widget16.vue?vue&type=template&id=f84ccbdc&scoped=true"
import script from "./Widget16.vue?vue&type=script&lang=js"
export * from "./Widget16.vue?vue&type=script&lang=js"

import "./Widget16.vue?vue&type=style&index=0&id=f84ccbdc&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84ccbdc"]])

export default __exports__